module.exports = __webpack_public_path__ + "img/nav-design-withdiamonds@2x.c59cf71.webp";